import React, {Fragment, useContext, useEffect, useState} from "react";
import { useQueryClient } from "react-query";
import __ from "lodash";
import {Stack} from "@mui/material";
import {makeStyles} from "@material-ui/core/styles";
import {SendTimeExtension} from "@mui/icons-material";
import {
  Box,
  ClickAwayListener,
  Divider,
  Grow,
  Icon,
  MenuList,
  Paper,
  Popper,
  Tooltip,
  withStyles
} from "@material-ui/core";
import {
  SaveAlt,
  MailOutlined,
} from "@material-ui/icons";
import Icons, {
  AirCargoIcon,
  AirportSlotIcon,
  ChecklistIcon,
  DocumentsIcon,
  FlightRouteIcon,
  FoodIcon,
  HandshakeIcon,
  Messages,
  NotesIcon,
  PassengerIcon,
  PilotIcon,
  ReportsIcon,
  WorldCheckIcon,
} from "../../../icons";
import SystemContext from "../../../SystemContext";
import TripToolTipStyles from "../../../controls/RouteView2/TripToolTipStyles";
import {buildMenuItems} from "../../../controls/IconButtonMenu";
import { useTripLegSpecialLoads } from "../../../services/trips";


const listActionOptions = [
  {action: "Download Trip Sheet Report", itemLabel: "Download Trip Sheet Report", itemIcon: <SaveAlt/>, historySuffix: "", display: "always", attachedTo: "reports"},
  {action: "Email Trip Sheet Report", itemLabel: "Email Trip Sheet Report", itemIcon: <MailOutlined/>, historySuffix: "", display: "always", attachedTo: "reports"},
  {action: "Download Flight Sheet Report", itemLabel: "Download Flight Sheet Report", itemIcon: <SaveAlt/>, historySuffix: "", display: "always", attachedTo: "reports"},
  {action: "Email Flight Sheet Report", itemLabel: "Email Flight Sheet Report", itemIcon: <MailOutlined/>, historySuffix: "", display: "always", attachedTo: "reports"},
];

const emptySlr = {
  slr: {count: 0, records: []},
  dgr: {count: 0, records: []},
  temp: {count: 0, records: []},
  avi: {count: 0, records: []},
}

const TabBarBox = withStyles(theme => ({
  root: {
    padding: 0,
    paddingTop: 12,
    paddingBottom: 6,
    color: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.primary.light
    },
    '&.Mui-selected:hover': {
      backgroundColor: 'transparent'
    },
    '&.tabSelected': {
      color: theme.palette.primary.main
    }
  },
}))(Box);

const Tags = (props) => {
  const {tags} = props;
  if (!tags || !Array.isArray(tags) || tags.length === 0) {
    return null;
  }
  return (
    <div style={{position: "relative", bottom: 0, left: -4, width: "100%", height: 12, backgroundColor: "rgba(0,0,0,0.07)", padding: 0 }}>
      <div style={{position: "relative", top: 2, width: "100%", textAlign:"center"}}>
        <Stack
          direction="row"
          spacing={0}
          justifyContent="space-around"
          alignContent="center"
        >
          {props.tags.map(tag => (
            <div>{tag}</div>
          ))}
        </Stack>
      </div>
    </div>
  )
}

const TabBarIconButton = (props) => {
  return (
    <Tooltip title={props.tooltip?.text} placement={props.tooltip?.placement}>
      <TabBarBox
        className={props.className}
        onClick={props.onClick}
      >
        <div style={{...props.iconStyle, width: 40, textAlign: "center"}}>
          {props.children}
        </div>
        <Tags tags={props.tags}/>
      </TabBarBox>
    </Tooltip>
  );
}

const TabBar = (props) => {
  const [selectedTab, setSelectedTab] = useState("");
  const [openMenu, setOpenMenu] = React.useState(false);
  const anchorRef = React.useRef(null);

  const menuItems = listActionOptions;
  const callback = props.callback;
  const callbackParams = {};

  const specialLoads = props.specialLoads;

  let cargoTags = [];

  if (specialLoads) {
    const {slr, dgr, temp, avi} = specialLoads;

    if (slr && slr.count > 0) {
      cargoTags.push(<Icons style={{fontSize: 12, padding: 1, marginTop: -4}} color="secondary">SlrIcon</Icons>)
    }
    if (dgr && dgr.count > 0) {
      cargoTags.push(<Icons style={{fontSize: 12, padding: 1, marginTop: -4}} color="secondary">warning_amber</Icons>)
    }
    if (temp && temp.count > 0) {
      cargoTags.push(<Icons style={{fontSize: 12, padding: 1, marginTop: -4}} color="secondary">thermostat</Icons>)
    }
    if (avi && avi.count > 0) {
      cargoTags.push(<Icons style={{fontSize: 12, padding: 1, marginTop: -4}} color="secondary">AviIcon</Icons>)
    }
  }

  const handleMenuClose = (event, action, extraData) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    const items = menuItems.map((menuItem) => {
      return __.isString(menuItem) ? menuItem : menuItem.action;
    });

    if (action && items.includes(action)) {
      const item = __.find(menuItems, {action: action});
      callbackParams["selectedAction"] = action;
      callbackParams["selectedOption"] = event.currentTarget.outerText;
      callbackParams["tab"] = item && __.has(item, "attachedTo") ? item.attachedTo : undefined;
      callback(callbackParams);
    } else if (event.currentTarget && items.includes(event.currentTarget.outerText)) {
      callbackParams["selectedOption"] = event.currentTarget.outerText;
      callback(callbackParams);
    }

    setOpenMenu(false);
  };

  const handleTabSelection = (tab) => {
    setSelectedTab(tab);
    if (props.callback) {
      props.callback(tab);
    }
  }

  return (
    <div>
      <Stack
        direction="row"
        spacing={0}
        justifyContent="space-around"
        alignContent="center"
        divider={<Divider orientation="vertical" flexItem />}
      >
        <item><TabBarIconButton className={selectedTab==="map"?"tabSelected":""} onClick={()=>{handleTabSelection("map")}} tooltip={{text: "Trip Details", placement:"left"}}><FlightRouteIcon fontSize="large"/></TabBarIconButton></item>
        <item><TabBarIconButton className={selectedTab==="timing"?"tabSelected":""} onClick={()=>{handleTabSelection("timing")}} tooltip={{text: "Flight Route", placement:"right"}}><Icon fontSize="large">location_on</Icon></TabBarIconButton></item>
      </Stack>
      <div style={{backgroundColor: "#d0d0d0", width: "calc(100% + 14px)", height: 1, marginLeft: -7}}></div>
      <Stack
        direction="row"
        spacing={0}
        justifyContent="space-around"
        alignContent="center"
        divider={<Divider orientation="vertical" flexItem />}
      >
        <item><TabBarIconButton className={selectedTab==="permits"?"tabSelected":""} onClick={()=>{handleTabSelection("permits")}} tooltip={{text: "Permits", placement:"left"}}><WorldCheckIcon fontSize="large"/></TabBarIconButton></item>
        <item><TabBarIconButton className={selectedTab==="slots"?"tabSelected":""} onClick={()=>{handleTabSelection("slots")}} tooltip={{text: "Slots", placement:"right"}}><AirportSlotIcon fontSize="large"/></TabBarIconButton></item>
      </Stack>
      <div style={{backgroundColor: "#d0d0d0", width: "calc(100% + 14px)", height: 1, marginLeft: -7}}></div>
      <Stack
        direction="row"
        spacing={0}
        justifyContent="space-around"
        alignContent="center"
        divider={<Divider orientation="vertical" flexItem />}
      >
        <item><TabBarIconButton className={selectedTab==="crew"?"tabSelected":""} onClick={()=>{handleTabSelection("crew")}} tooltip={{text: "Crew", placement:"left"}}><PilotIcon fontSize="large"/></TabBarIconButton></item>
        <item><TabBarIconButton className={selectedTab==="pax"?"tabSelected":""} onClick={()=>{handleTabSelection("pax")}} tooltip={{text: "Passengers", placement:"right"}}><PassengerIcon fontSize="large"/></TabBarIconButton></item>
      </Stack>
      <div style={{backgroundColor: "#d0d0d0", width: "calc(100% + 14px)", height: 1, marginLeft: -7}}></div>
      <Stack
        direction="row"
        spacing={0}
        justifyContent="space-around"
        alignContent="center"
        divider={<Divider orientation="vertical" flexItem />}
      >
        <item><TabBarIconButton className={selectedTab==="partners"?"tabSelected":""} onClick={()=>{handleTabSelection("partners")}} tooltip={{text: "Services", placement:"left"}}><HandshakeIcon fontSize="large"/></TabBarIconButton></item>
        <item><TabBarIconButton className={selectedTab==="catering"?"tabSelected":""} onClick={()=>{handleTabSelection("catering")}} tooltip={{text: "Catering", placement:"right"}}><FoodIcon fontSize="large"/></TabBarIconButton></item>
      </Stack>
      <div style={{backgroundColor: "#d0d0d0", width: "calc(100% + 14px)", height: 1, marginLeft: -7}}></div>
      <Stack
        direction="row"
        spacing={0}
        justifyContent="space-around"
        alignContent="center"
        divider={<Divider orientation="vertical" flexItem />}
      >
        <item><TabBarIconButton className={selectedTab==="cargo"?"tabSelected":""} tags={cargoTags} onClick={()=>{handleTabSelection({tab: "cargo", selectedAction: specialLoads})}} tooltip={{text: "Cargo Details", placement:"left"}}><AirCargoIcon fontSize="large"/></TabBarIconButton></item>
        <item><TabBarIconButton className={selectedTab==="fuel"?"tabSelected":""} onClick={()=>{handleTabSelection("fuel")}} tooltip={{text: "Fuel Log", placement:"right"}}><Icon fontSize="large">local_gas_station</Icon></TabBarIconButton></item>
      </Stack>
      <div style={{backgroundColor: "#d0d0d0", width: "calc(100% + 14px)", height: 1, marginLeft: -7}}></div>
      <Stack
        direction="row"
        spacing={0}
        justifyContent="space-around"
        alignContent="center"
        divider={<Divider orientation="vertical" flexItem />}
      >
        <item><TabBarIconButton className={selectedTab==="checklist"?"tabSelected":""} onClick={()=>{handleTabSelection("checklist")}} tooltip={{text: "Dispatch Checklist", placement:"left"}}><ChecklistIcon fontSize="large"/></TabBarIconButton></item>
        <item><TabBarIconButton className={selectedTab==="checklist"?"tabSelected":""} onClick={()=>{handleTabSelection("dispatchchecklist")}} tooltip={{text: "Download Dispatch Checklist", placement:"right"}}><SendTimeExtension fontSize="large"/></TabBarIconButton></item>
      </Stack>
      <div style={{backgroundColor: "#d0d0d0", width: "calc(100% + 14px)", height: 1, marginLeft: -7}}></div>
      <Stack
        direction="row"
        spacing={0}
        justifyContent="space-around"
        alignContent="center"
        divider={<Divider orientation="vertical" flexItem/>}
        ref={anchorRef}
      >
        <item><TabBarIconButton className={selectedTab === "notes" ? "tabSelected" : ""} onClick={() => {handleTabSelection("notes")}} tooltip={{text: "Notes", placement: "left"}}><NotesIcon fontSize="large"/></TabBarIconButton></item>
        <item><TabBarIconButton className={selectedTab === "documents" ? "tabSelected" : ""} onClick={() => {handleTabSelection("documents")}} tooltip={{text: "Attached Documents", placement: "right"}}><DocumentsIcon fontSize="large"/></TabBarIconButton></item>
      </Stack>
      <div style={{backgroundColor: "#d0d0d0", width: "calc(100% + 14px)", height: 1, marginLeft: -7}}></div>
      <Stack
        direction="row"
        spacing={0}
        justifyContent="space-around"
        alignContent="center"
        divider={<Divider orientation="vertical" flexItem/>}
      >
        <item>
          <TabBarIconButton className={selectedTab === "reports" ? "tabSelected" : ""} onClick={() => {
          }} tooltip={{text: "Trip Sheet Report", placement: "left"}}>
            <React.Fragment>
              <ReportsIcon fontSize="large" onClick={() => {
                setOpenMenu((prevOpen) => !prevOpen)
              }}/>
              <Popper open={openMenu} anchorEl={anchorRef.current} transition placement={'top-end'}
                      style={{zIndex: props.zIndex || 1900}}>
                {({TransitionProps, placement}) => (
                  <Grow
                    {...TransitionProps}
                    style={{transformOrigin: placement !== 'bottom' ? 'length top' : 'length bottom'}}
                  >
                    <Paper style={{border: '1px solid #d3d4d5',}}>
                      <ClickAwayListener onClickAway={handleMenuClose}>
                        <MenuList>
                          {
                            buildMenuItems(menuItems, props.style, handleMenuClose)
                          }
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </React.Fragment>
          </TabBarIconButton>
        </item>
        <item><TabBarIconButton className={selectedTab === "messages" ? "tabSelected" : ""} onClick={() => {
          handleTabSelection("messages")
        }} tooltip={{text: "Flight Messages", placement: "right"}}><Messages fontSize="large"/></TabBarIconButton></item>
        {/*<item><TabBarIconButton className={selectedTab==="notes"?"tabSelected":""} onClick={()=>{handleTabSelection("notes")}} tooltip={{text: "Notes", placement:"right"}}><NotesIcon fontSize="large"/></TabBarIconButton></item>*/}
      </Stack>
    </div>
  )
}


const ActionPanel = (props) => {
  const {editing, eventBus, colours, onChange, record} = props;

  const classes = makeStyles(TripToolTipStyles)();

  const [selectedScreen, setSelectedScreen] = useState("");

  const specialLoads = props.specialLoads;

  const tabChanged = (tabNo) => {
    let currentTab = tabNo;
    let additionalActionData = undefined;
    if (typeof tabNo === "object") {
      currentTab = tabNo.tab;
      additionalActionData = tabNo.selectedAction;
    }
    setSelectedScreen(currentTab);
    if (onChange)
      onChange(currentTab, record, additionalActionData);
  }

  return (
    <Fragment>
      <div style={{
        width: "calc(100% + 8px)",
        textAlign: "center",
        backgroundColor: "rgba(255,255,255,0.9)",
        marginLeft: -4,
        marginTop: 10,
        borderRadius: "0px 0px 3px 3px"
      }}>
        <div style={{width: "calc(100% - 16px)", marginLeft: 8, marginRight: 8}}>
          <TabBar callback={tabChanged} specialLoads={specialLoads}/>
        </div>
      </div>
    </Fragment>
  )
}

const FlightTooltip = (props) => {

  const {editing, colours, onChange, record} = props;

  const classes = makeStyles(TripToolTipStyles)();

  const [toolTipText, setToolTipText] = useState("");
  const [opened, setOpened] = useState(false);

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  const queryClient = useQueryClient();
  const specialLoads = useTripLegSpecialLoads({queryClient, extraKeys: [record.tripLegUuid]});

  // useEffect(()=> {
  //   const open = async () => {
  //     //openToolTip();
  //   }
  //   //eventBus.bind("FlightTooltip.open", open);
  //
  //   return () => {
  //     eventBus.unbind("FlightTooltip.open", open);
  //   }
  // }, []);


  const openToolTip = () => {
    if (!opened) {
      console.log('opening');
      setOpened(true);
      //if (tripData) {
      if (true) {
        setToolTipText(
          <ActionPanel
            editing={editing}
            eventBus={eventBus}
            classes={classes}
            colours={colours}
            onChange={onChange}
            record={record}
            specialLoads={specialLoads?.data}
          />
        );
      }
    }
  }

  return (
    specialLoads ?
    <Tooltip onOpen={openToolTip} onClose={props.onClose} arrow interactive
             classes={{ tooltip: classes.flightToolTip }}
             placement="right"
             title={toolTipText}
             //leaveDelay={10}
    >
      {props.children}
    </Tooltip>
      : <></>
  );
}

export default FlightTooltip;
